import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import React from "react";
import { IoClose } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import ConfirmationModal from "../../Components/Modals/ConfirmationModal";
import CreateMeetModal from "../../Components/Modals/CreateMeetModal";
import FilterModal from "../../Components/Modals/FilterModal";
import NotesModal from "../../Components/Modals/NotesModal";
import RelevanceModalBuyer from "../../Components/Modals/RelevanceModalBuyer";
import SortModal from "../../Components/Modals/SortModal";
import ViewDocsModal from "../../Components/Modals/ViewDocsModal";

// Claude: extracted from SellersList.tsx 23-03-2026
interface Props {
  navigate: (path: string) => void;
  sortModal: boolean; handleCloseSortModal: () => void; orderSort: string; setOrderSort: (v: string) => void;
  meetConfirm: boolean; handleCloseMeetConfirmModal: () => void; currentMeet: string;
  tagsModel: boolean; handleCloseTagsModal: () => void; tagsData: string[];
  filterModal: boolean; handleCloseFilterModal: () => void; relevanceSort: string; setRelevanceSort: (v: string) => void;
  interestedTags: string[]; selectedTags: string[]; setSelectedTags: (v: string[]) => void;
  tagsFilter: boolean; handleCloseTagsFilterModal: () => void;
  meetModal: boolean; handleCloseMeetModal: () => void; meetResponder: any;
  releModal: boolean; handleCloseRelevanceModal: () => void; relevanceData: any; reloadData: () => void;
  notesModal: boolean; handleCloseNotesModal: () => void; notesData: any;
  docsModal: boolean; handleCloseDocsModal: () => void; personName: string; sellerAsset: any;
  verifyGateOpen: boolean; setVerifyGateOpen: (v: boolean) => void;
}

const SellersListModals = ({
  navigate,
  sortModal, handleCloseSortModal, orderSort, setOrderSort,
  meetConfirm, handleCloseMeetConfirmModal, currentMeet,
  tagsModel, handleCloseTagsModal, tagsData,
  filterModal, handleCloseFilterModal, relevanceSort, setRelevanceSort, interestedTags, selectedTags, setSelectedTags,
  tagsFilter, handleCloseTagsFilterModal,
  meetModal, handleCloseMeetModal, meetResponder,
  releModal, handleCloseRelevanceModal, relevanceData, reloadData,
  notesModal, handleCloseNotesModal, notesData,
  docsModal, handleCloseDocsModal, personName, sellerAsset,
  verifyGateOpen, setVerifyGateOpen,
}: Props) => (
  <>
    {/* Sort */}
    <Modal closeIcon={null} footer={null} title={null} open={sortModal} onOk={handleCloseSortModal} onCancel={handleCloseSortModal}>
      <SortModal handleCloseModal={handleCloseSortModal} orderSort={orderSort} setOrderSort={setOrderSort} />
    </Modal>

    {/* MeetConfirm */}
    <Modal closeIcon={null} footer={null} title={null} open={meetConfirm} onOk={handleCloseMeetConfirmModal} onCancel={handleCloseMeetConfirmModal}>
      <ConfirmationModal
        handleCloseModal={handleCloseMeetConfirmModal}
        handleSubmit={() => navigate("/buyer/calendar?id=" + currentMeet)}
        title={"Open meeting already exists"}
        message={"Please view & edit the same.  View details now ?"}
        confirmBtnText={"Yes, View"}
        rejectButtonText={"No"}
      />
    </Modal>

    {/* Tags display */}
    <Modal closeIcon={null} footer={null} title={null} open={tagsModel} onOk={handleCloseTagsModal} onCancel={handleCloseTagsModal}>
      <Box>
        <Box position={"relative"} display={"flex"} justifyContent={"center"} alignItems={"center"} h={"60px"}>
          <Text fontSize={"sm"} fontWeight={"regular"} textAlign={"center"} color={"black"}>Tags</Text>
          <Box position={"absolute"} right={0} top={0} py={3} cursor={"pointer"}>
            <MdClose size={20} onClick={handleCloseTagsModal} />
          </Box>
        </Box>
        {/* Claude: scrollable tags list 25-03-2026 */}
        <Flex flexWrap={"wrap"} gap={2} my={8} maxH="50vh" overflowY="auto">
          {tagsData?.map((tag: any) => (
            <span
              key={tag}
              className="whitespace-nowrap"
              style={{ padding: "3px 7px", color: "#000000", fontFamily: `"Inter Variable", sans-serif`, fontWeight: "light", backgroundColor: "#FFD2CD", borderRadius: "3px" }}
            >
              {tag}
            </span>
          ))}
        </Flex>
      </Box>
    </Modal>

    {/* Filter */}
    <Modal closeIcon={null} footer={null} title={null} open={filterModal} onOk={handleCloseFilterModal} onCancel={handleCloseFilterModal}>
      <FilterModal
        handleCloseModal={handleCloseFilterModal}
        relevanceSort={relevanceSort}
        role="Buyer"
        setRelevanceSort={setRelevanceSort}
        interestedTags={interestedTags}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
      />
    </Modal>

    {/* Tags filter */}
    <Modal closeIcon={null} footer={null} title={null} open={tagsFilter} onOk={handleCloseTagsFilterModal} onCancel={handleCloseTagsFilterModal}>
      <Flex gap={"16px"} direction={"column"}>
        <Box position={"relative"} display={"flex"} justifyContent={"center"} alignItems={"center"} h={"60px"}>
          <Text fontSize={"sm"} fontWeight={"regular"} textAlign={"center"} color={"black"}>Tags</Text>
          <Box position={"absolute"} right={0} top={0} py={3} cursor={"pointer"}>
            <MdClose size={20} onClick={handleCloseTagsFilterModal} />
          </Box>
        </Box>
        {/* Claude: scrollable tags filter list 25-03-2026 */}
        {interestedTags && interestedTags.length > 0 ? (
          <Flex alignItems={"center"} flexWrap={"wrap"} gap={"8px"} maxH="50vh" overflowY="auto">
            {interestedTags.map((val: any, ind: number) => {
              if (selectedTags?.includes(val))
                return (
                  <Box
                    key={ind}
                    color={"#FFF"}
                    display={"flex"}
                    alignItems={"center"}
                    style={{ padding: "3px 7px", color: "#FFF", fontFamily: `"Inter Variable", sans-serif`, fontWeight: "light", backgroundColor: "#FF8D80", borderRadius: "3px", whiteSpace: "nowrap" }}
                    onClick={() => {
                      const temp = [...selectedTags];
                      temp.splice(temp.indexOf(val), 1);
                      setSelectedTags(temp);
                    }}
                  >
                    <Text fontSize={"sm"} fontWeight={500}>{val}</Text>
                    <IoClose />
                  </Box>
                );
              return (
                <Box
                  key={ind}
                  onClick={() => setSelectedTags([...selectedTags, val])}
                  style={{ padding: "3px 7px", color: "#000000", fontFamily: `"Inter Variable", sans-serif`, fontWeight: "light", backgroundColor: "#FFD2CD", borderRadius: "3px" }}
                >
                  <Text fontSize={"sm"} fontWeight={500}>{val}</Text>
                </Box>
              );
            })}
          </Flex>
        ) : (
          <Text fontSize={"sm"} fontWeight={500}>No tags Found</Text>
        )}
      </Flex>
    </Modal>

    {/* Meet */}
    <Modal closeIcon={null} footer={null} title={null} open={meetModal} onOk={handleCloseMeetModal} onCancel={handleCloseMeetModal}>
      <CreateMeetModal
        responderId={meetResponder?.sellers?.userId}
        company={meetResponder?.companyName}
        eventId={meetResponder?.eventId}
        context="Inquiry"
        handleCloseModal={handleCloseMeetModal}
      />
    </Modal>

    {/* Relevance */}
    <Modal closeIcon={null} footer={null} title={null} open={releModal} onOk={handleCloseRelevanceModal} onCancel={handleCloseRelevanceModal} destroyOnClose>
      <RelevanceModalBuyer data={relevanceData} relaodData={reloadData} handleCloseModal={handleCloseRelevanceModal} />
    </Modal>

    {/* Notes */}
    <Modal closeIcon={null} footer={null} title={null} open={notesModal} onOk={handleCloseNotesModal} onCancel={handleCloseNotesModal}>
      <NotesModal eventId={notesData.eventId} forUser={notesData.forUser} handleCloseModal={handleCloseNotesModal} />
    </Modal>

    {/* Docs */}
    <Modal closeIcon={null} footer={null} title={null} open={docsModal} onOk={handleCloseDocsModal} onCancel={handleCloseDocsModal}>
      <ViewDocsModal sellerName={personName} docLinks={sellerAsset.links} handleCloseModal={handleCloseDocsModal} />
    </Modal>

    {/* VerifyGate */}
    <Modal open={verifyGateOpen} onCancel={() => setVerifyGateOpen(false)} footer={null} title={null} closeIcon={null} centered>
      <Box py={2}>
        <Text fontSize="md" fontWeight={600} mb={2} color="#0E122F">Profile Verification Required</Text>
        <Text fontSize="sm" color="gray.600" mb={5}>Please complete your profile verification to use this feature.</Text>
        <Flex gap={2} justifyContent="flex-end">
          <Button size="sm" variant="ghost" onClick={() => setVerifyGateOpen(false)}>Cancel</Button>
          <Button size="sm" bg="#0E122F" color="white" borderRadius="8px" _hover={{ bg: "#2E3560" }}
            onClick={() => { setVerifyGateOpen(false); navigate("/buyer/profile"); }}>
            Go to Profile
          </Button>
        </Flex>
      </Box>
    </Modal>
  </>
);

export default SellersListModals;
